/* Queries excluidas del refactor Pattern 3 — no compatibles con campos estáticos */
import { gql } from "@apollo/client";
import { DOMAIN_CONFIG } from "../shared/domainConfig";

/* GET_DOMAINS: genera dinámicamente la query a partir de DOMAIN_CONFIG usando .map()
   en tiempo de ejecución — no es jsonToGraphQLQuery con DEFAULT_FIELDS estático,
   por lo que no puede convertirse a static en el patrón de refactor. */
export const GET_DOMAINS = () => {
  const domainsQuery = DOMAIN_CONFIG.map(
    ({ type, alias }) => `
      ${alias}: domains(
        where: {
          type: { equals: "${type}" }
          deleted_at: { equals: null }
        }
        orderBy: { id: asc }
      ) {
        id
        name
        extras
        parent_id
      }
    `
  ).join('\n')

  return gql`
    query GET_DOMAINS {
      ${domainsQuery}
    }
  `
}
